import Vue from 'vue'
import VueRouter from 'vue-router'

//App Component
import Home from '../views/Home.vue'
import CaraKerja from '../views/Pages/CaraKerja.vue'
import Daftar from '../views/Pages/Daftar.vue'
import Masuk from '../views/Pages/Masuk.vue'
import KategoriDetail from '../views/Pages/KategoriDetail.vue'
import Keranjang from '../views/Pages/Keranjang.vue'
import Address from '../views/Pages/CheckOut/Address.vue'
import ListPo from '../views/Pages/ListPo.vue'
import ListProduk from '../views/Pages/ListProduk.vue'
import DetailPo from '../views/Pages/DetailPo.vue'

//Special Page
import OrderConfirmation from '../views/Pages/SpecialPage/OrderConfirmation.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/carakerja',
    name: 'CaraKerja',
    component: CaraKerja
  },
  {
    path: '/daftar',
    name: 'Daftar',
    component: Daftar
  },
  {
    path: '/masuk',
    name: 'Masuk',
    component: Masuk
  },
  {
    path: '/kategori-detail',
    name: 'KategoriDetail',
    component: KategoriDetail
  },
  {
    path: '/keranjang',
    name: 'Keranjang',
    component: Keranjang
  },
  {
    path: '/address',
    name: 'Address',
    component: Address
  },
  {
    path: '/listpo',
    name: 'ListPo',
    component: ListPo
  },
  {
    path: '/listproduk',
    name: 'ListProduk',
    component: ListProduk
  },
  {
    path: '/detailpo',
    name: 'DetailPo',
    component: DetailPo
  },
  {
    path: '/orderconfirmation',
    name: 'OrderConfirmation',
    component: OrderConfirmation
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
